module.exports = __webpack_public_path__ + "8ae2dc6f105f19558e431c654fac4f91.svg";